import { isInsufficientCreditsError } from '@/lib/plusCreditOptions';
import { isToolModelPlusLocked, resolveToolPickerModels } from './toolDetailHelpers';

export function isRejectedImageToolRun(tool, run) {
  if (!['image-generator', 'image-editor'].includes(tool?.slug) || run?.status !== 'failed') return false;
  if (isInsufficientCreditsError(run.error)) return false;
  const error = run.error;
  const description = typeof error === 'string' ? error : [error?.code, error?.message].filter(Boolean).join(' ');
  return /content[ _-]*(policy|filter|checker|moderation)|safety[ _-]*(system|filter|check|violation)|moderation[ _-]*blocked|\b(rejected|refused|blocked|nsfw|inappropriate content|sensitive content)\b/i.test(description);
}

export function getImageToolRetryModel(tool, run, modelStore, user) {
  if (!isRejectedImageToolRun(tool, run) || !run?.inputs) return null;
  const used = Array.isArray(run.modelsUsed) ? run.modelsUsed : [];
  // Without a recorded model we cannot promise that the retry is different.
  if (!used.length) return null;
  const ids = new Set(used.map(model => String(model?.id || model?._id || model)));
  const slugs = new Set(used.map(model => model?.slug).filter(Boolean));
  return resolveToolPickerModels(tool, modelStore).find(model => {
    if (ids.has(String(model.id)) || slugs.has(model.slug) || isToolModelPlusLocked(model, user)) return false;
    // A generation retry must not select an editor that requires an upload.
    if (tool.slug === 'image-generator' && model.parameters?.some(parameter => (
      parameter.validation?.required && parameter.validation?.file?.fileType === 'image'
    ))) return false;
    return true;
  }) || null;
}

// Apply the same model-bound option reconciliation as the form when changing
// models. The prompt and uploaded file references are kept from the failed run.
export function getImageToolRetryInputs(tool, run, model, resolveBoundField) {
  const inputs = { ...run.inputs };
  for (const field of tool.fields || []) {
    if (!field.bindToModelParameter) continue;
    const resolved = resolveBoundField(field, model);
    if (resolved === field) continue;
    const allowed = (resolved.validation?.options || []).map(option => option.value);
    const current = inputs[field.name];
    if (current == null || (allowed.length && !allowed.some(value => String(value) === String(current)))) {
      const defaultValue = resolved.validation?.default ?? resolved.value;
      inputs[field.name] = defaultValue != null && (!allowed.length || allowed.some(value => String(value) === String(defaultValue)))
        ? defaultValue : allowed[0];
    }
  }
  return inputs;
}
